<template>
     <section id="Testimony">
      <div class="container px-2 py-4" id="custom-cards">
        <div class="p-5 text-center bg-body-tertiary rounded-3">
        <img src="images/review_icon.png" width="80">
        <h1 class="text-body-emphasis text-center">Customer Reviews</h1>
      </div>
        <div class="row row-cols-1 row-cols-lg-3 align-items-stretch g-4 py-2">
          <div class="col">
            <div class="card card-cover h-100 overflow-hidden text-bg-dark rounded-4 shadow-lg" style="background-image: url('./images/windows_apps\ \(Small\).png');" data-aos="flip-left">
              <div class="d-flex flex-column h-100 p-5 pb-3 text-white text-shadow-1">
                <p class="pt-5 mt-5 mb-4">Handicraft Managment System simple to maintan inventory, generate manual reports and easily monitor daily expense and earnings.</p>
                <ul class="d-flex list-unstyled mt-auto">
                  <li class="me-auto">
                    <img src="images/user-f.png" alt="Bootstrap" width="32" height="32" class="rounded-circle border border-white">
                    <small> Srei Mao</small>
                  </li>
                  <li class="d-flex align-items-center">
                    <small>General Manager</small>
                  </li>
                </ul>
              </div>
            </div>
          </div>
    
          <div class="col">
            <div class="card card-cover h-100 overflow-hidden text-bg-dark rounded-4 shadow-lg" style="background-image: url('./images/businessconsultant\ \(Small\).png');" data-aos="flip-left">
              <div class="d-flex flex-column h-100 p-5 pb-3 text-white text-shadow-1">
                <p class="pt-5 mt-5 mb-4">One-stop professional services for me to register my boss 's new businesses in Cambodia at MOC, GDT and MLVT.</p>
                <ul class="d-flex list-unstyled mt-auto">
                  <li class="me-auto">
                    <img src="images/user-m.png" alt="Bootstrap" width="32" height="32" class="rounded-circle border border-white">
                    <small> Heng Rithy</small>
                  </li>
                  <li class="d-flex align-items-center">
                    <svg class="bi me-2" width="1em" height="1em"><use xlink:href="#calendar3"></use></svg>
                    <small>Assistant to Director</small>
                  </li>
                </ul>
              </div>
            </div>
          </div>
    
          <div class="col">
            <div class="card card-cover h-100 overflow-hidden text-bg-dark rounded-4 shadow-lg" style="background-image: url('./images/webdesign\ \(Small\).png');" data-aos="flip-left">
              <div class="d-flex flex-column h-100 p-5 pb-3 text-shadow-1">
                <p class="pt-5 mt-5 mb-4">Make my business easy, when I have Catalog Website, Easy to control stock, update price and customers easy to filter their needed products.</p>
                <ul class="d-flex list-unstyled mt-auto">
                  <li class="me-auto">
                    <img src="images/user-g.png" alt="Bootstrap" width="32" height="32" class="rounded-circle border border-white">
                    <small> Le Chih</small>
                  </li>
                  <li class="d-flex align-items-center">
                    <small>Business Owner</small>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>